import { useEffect, useState } from 'react';

import { ApplicationUuid } from '@bringg/types';

import { useStores } from 'bringg-web/recipes';

// BRNGG-57702: DeliveryWindowUtilizationApp (AIT-Peloton capacity sync) — its own dedicated Bringg
// application, registered by BRNGG-57766. hagmonia's Application::APPLICATIONS_GUIDS carries it as
// `delivery_window_utilization` — a distinct entry from the unrelated `capacity_planning` app; the
// two are easy to confuse since @bringg/types names them CapacityPlanning / DeliveryWindowUtilizationApp.
//
// Enablement moved from a per-team ATC flag to the merchant-level ApplicationMerchantConfiguration's
// `team_ids` array (BRNGG-57995) — both the merchant install and the team's membership in that list
// must hold before the max_task_capacity field / used-remaining card are shown.
type DeliveryWindowUtilizationConfig = {
	team_ids?: number[];
	service_plan_id?: number;
};

export type DeliveryWindowCapacityTeamIds = {
	isInstalled: boolean;
	teamIds: number[];
};

// Fetched once per view (not per calendar event) — calling this per-event would fan out one
// fetchConfiguration request per concurrently rendered event on first paint.
export const useDeliveryWindowCapacityTeamIds = (): DeliveryWindowCapacityTeamIds => {
	const { applicationStore, applicationMerchantConfigurationStore } = useStores();
	const [teamIds, setTeamIds] = useState<number[]>([]);

	const isInstalled = applicationStore.isApplicationInstalled(ApplicationUuid.DeliveryWindowUtilizationApp);

	useEffect(() => {
		if (!isInstalled) {
			return;
		}
		let cancelled = false;

		const fetchTeamIds = async () => {
			try {
				const config: DeliveryWindowUtilizationConfig | null =
					await applicationMerchantConfigurationStore.fetchConfiguration(
						ApplicationUuid.DeliveryWindowUtilizationApp
					);
				if (!cancelled) {
					setTeamIds(config?.team_ids ?? []);
				}
			} catch (error) {
				console.error('failed to fetch delivery window utilization configuration: ', error);
			}
		};

		fetchTeamIds();

		return () => {
			cancelled = true;
		};
	}, [isInstalled, applicationMerchantConfigurationStore]);

	return { isInstalled, teamIds };
};
